import { appUrls } from "../../utils/urls/appUrls";

import {
  // Dashboard,
  SearchResult,
  // DigitalLetter,
  // ProfileCreation,
  // ProfileCompletionSuccess,
  // UserProfile,
  // PrintLetter,
  TransfereeCertificateManagement,
  TransfereeCertificateView,
} from "../../app/pages";
import TransactionHistory from "../../app/pages/CertificateManagement/TransactionHistory";

export const transfereeRoutes = [
  // {
  // 	url: appUrls.dashboard,
  // 	component: <Dashboard />,
  // 	routeType: 'private'
  // },
  {
    url: appUrls.certificates,
    component: <TransfereeCertificateManagement />,
    routeType: "private",
  },
  {
    url: appUrls.certificates_search,
    component: <SearchResult />,
    routeType: "private",
  },
  {
    url: appUrls.certificates_view,
    component: <TransfereeCertificateView />,
    routeType: "private",
  },
  // {
  // 	url: `${appUrls.digitalLetterBase}`,
  // 	component: <DigitalLetter />,
  // 	routeType: 'private'
  // },
  // {
  // 	url: appUrls.profileCreation,
  // 	component: <ProfileCreation />,
  // 	routeType: 'private'
  // },
  // {
  // 	url: appUrls.profileCreationSuccess,
  // 	component: <ProfileCompletionSuccess />,
  // 	routeType: 'private'
  // },
  // {
  // 	url: appUrls.user_profile,
  // 	component: <UserProfile />,
  // 	routeType: 'private'
  // },
  {
    url: appUrls.transactionHistory,
    component: <TransactionHistory />,
    routeType: "private",
  },
  // {
  // 	url: appUrls.print,
  // 	component: <PrintLetter />,
  // 	routeType: 'private'
  // },
];
